
import { Component, Prop, Vue } from 'vue-property-decorator'
import LearningProgressTip from '@/components/organisms/LearningProgressTip.vue'
import { SystemChartUnit } from '@/models/SystemChart'

/**
 * 知識MAPのチャートに配置する単元情報
 */
@Component({
  components: {
    LearningProgressTip,
  },
})
export default class LearningChartUnit extends Vue {
  /** 知識MAP単元情報 */
  @Prop()
  private systemChartUnit!: SystemChartUnit

  /** クリック時のイベント */
  @Prop()
  private onSelectUnit!: (id: number) => void

  /**
   * 単元情報からcssの設定を展開
   *
   * @returns スタイル情報
   */
  private setStyle(): { [key: string]: string } {
    return {
      '--position-x': `${this.systemChartUnit.xPosition}px`,
      '--position-y': `${this.systemChartUnit.yPosition}px`,
    }
  }
}
